import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Eventph from "../../assets/pic/event.jpg"
import {Helmet} from "react-helmet";

const EventEn = ()=>{
    return(
        <div className='event-wrap'>
            <Helmet>
                <title>Network events</title>
                <meta name="description" content="Many large companies used their local area network (LAN) to hold intra-organizational events" />
            </Helmet>
            <Nav/>
            <div className='webinar-dec'>
                <h1>Network events</h1>
                <img src={Eventph} alt="Network events"/>
                <p>
                    Holding a meeting or event could be carried out virtually. Many large companies used their local area network (LAN) to hold intra-organizational events. Using local networks makes it difficult for people outside the organization to participate in organizational meetings and events.
                </p>
                <p>
                    One solution to resolve this problem is using the World Wide Web –or the internet for short. The internet is a context used by many small and large businesses to handle their affairs.
                </p>
                <p>
                    Holding network (online) events enables everyone to participate in the meetings regardless of their geographical location. Comprehensive platforms used for holding virtual meetings must include all the standard interactive tools including:
                </p>
                <ul>
                    <li>•	High-quality audio interaction</li>
                    <li>•	High-quality video interaction with the possibility of multiple video connections</li>
                    <li>•	Playing videos online </li>
                    <li>•	Text conversation and interaction (chatting)</li>
                    <li>•	Sharing files</li>
                    <li>•	Sharing desktops</li>
                    <li>•	The possibility of displaying important announcements or messages in the meeting environment periodically</li>
                </ul>
                <p>
                    BellMeet comprehensive online meeting platform, the only knowledge-based and native platform, with the most complete interactive tools mentioned above, is prepared to host your network meetings or events so that you can have a more pleasant and efficient experience than in-person meetings.
                </p>
            </div>
            <Footer/>
        </div>
    )
}

export default EventEn